import React from 'react';
import { Image } from 'semantic-ui-react';
const {
  REACT_APP_ENJOY_DO_SPACE_ROOT
} = process.env;
const SupportedServices = () => /*#__PURE__*/React.createElement(Image.Group, {
  size: "tiny",
  style: {
    textAlign: 'center',
    marginLeft: '1em',
    marginRight: '1em'
  },
  id: "supportedServicesLogos"
}, /*#__PURE__*/React.createElement(Image, {
  src: "".concat(REACT_APP_ENJOY_DO_SPACE_ROOT, "/supported-provider-logos/amazon-prime-video.png"),
  style: {
    padding: '1em 0 0.4em 0'
  }
}), /*#__PURE__*/React.createElement(Image, {
  src: "".concat(REACT_APP_ENJOY_DO_SPACE_ROOT, "/supported-provider-logos/disney-plus.png"),
  style: {
    paddingTop: '0' /* paddingBottom: '1.4em' */
  }
}), /*#__PURE__*/React.createElement(Image, {
  src: "".concat(REACT_APP_ENJOY_DO_SPACE_ROOT, "/supported-provider-logos/hbo-max.png"),
  style: {
    width: '86px'
  }
}), /*#__PURE__*/React.createElement(Image, {
  src: "".concat(REACT_APP_ENJOY_DO_SPACE_ROOT, "/supported-provider-logos/hulu.png"),
  style: {
    paddingBottom: '1em'
  }
}), /*#__PURE__*/React.createElement(Image, {
  src: "".concat(REACT_APP_ENJOY_DO_SPACE_ROOT, "/supported-provider-logos/netflix.png")
}), /*#__PURE__*/React.createElement(Image, {
  src: "".concat(REACT_APP_ENJOY_DO_SPACE_ROOT, "/supported-provider-logos/peacock.png"),
  style: {
    width: '86px'
  }
}), /*#__PURE__*/React.createElement(Image, {
  src: "".concat(REACT_APP_ENJOY_DO_SPACE_ROOT, "/supported-provider-logos/youtube.png")
}));
export default SupportedServices;